import {Component, ElementRef, EventEmitter, HostListener, OnDestroy, OnInit, Output} from '@angular/core';
import { BlockableUI } from 'primeng/components/common/blockableui';

import {
  AccountService, ChangeFiltersService,
  Cookbook,
  CookbookService,
  CookbookTreeNode, HtmlHelper,
  RecipeService,
  UserCredentials,
} from '../shared/shared.module';
import {Router} from '@angular/router';

@Component({
  selector: 'app-cookbook-filter',
  templateUrl: './cookbook-filter.component.html',
  styleUrls: ['./cookbook-filter.component.scss']
})
export class CookbookFilterComponent implements OnInit, BlockableUI, OnDestroy {
  recipesCounter = null;
  cookbooksTree: CookbookTreeNode[] = [];
  blockedCookbooksTree: CookbookTreeNode[] = [];
  selectedCookbooks: CookbookTreeNode[] = [];
  blockedSelectedCookbooks: CookbookTreeNode[] = [];
  userCredentials: UserCredentials;
  isMobile = false;
  mobileListToggleStatus = false;
  windowWidth: number = window.innerWidth;
  isCheckedFirst = false;
  allowResetMenu;
  stateReadyMenu;
  @Output() booksFiltersAmountCheck = new EventEmitter<number>();

  constructor(
      private router: Router,
      private cookbookService: CookbookService,
      private recipeService: RecipeService,
      private accountService: AccountService,
      private el: ElementRef,
      private changeFiltersService: ChangeFiltersService,
  ) { }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.windowWidth = event.target.innerWidth;
    this.isMobile = HtmlHelper.checkMobile(this.windowWidth);
  }

  ngOnInit() {
    this.accountService.getCredentialsPromise().then(cred => {
      this.userCredentials = cred;

      this.cookbookService.get().then(x => {
        if (x) {
          const forbiddenBooks = Array.from(x);
          const allowedBooks: Cookbook[] = forbiddenBooks;

          this.cookbooksTree = this.convertToCookbookTree(allowedBooks);
          this.changeFiltersService.setListReadyMenu(this.cookbooksTree[0].children);
          this.blockedCookbooksTree = this.convertToCookbookTree(forbiddenBooks);
          if (this.userCredentials.Id_Tarif <= 1) {
            const indexOfactiveTreenode = this.blockedCookbooksTree.findIndex(book => book.label === 'Базовые рецепты');
            this.blockedSelectedCookbooks.push(this.blockedCookbooksTree[indexOfactiveTreenode]);
          }

          this.recipeService.sortHashObs.subscribe(num => {
            if (num === 3) {
              this.selectCookBookByHash(this.cookbooksTree, this.recipeService.booksIdHash);
              this.booksFiltersAmountCheck.emit(this.selectedCookbooks.length);
              const filterString = this.composeFilterString();
              this.recipeService.setFilter('SectionString', filterString);
              this.recipeService.pushProgressInHash('books');

              this.onTreeChange(true);
            }
          });
        }
      });

      this.recipeService.getTotalRecipes().subscribe(x => {
        if (x !== null) {
          this.recipesCounter = x;
        }
      });

      this.recipeService.getFilterState().subscribe(x => {
        if (x !== null && this.selectedCookbooks) {
          this.selectedCookbooks = [];
        }
      });
    });

    this.countBooksFiltersActive();

    this.isMobile = HtmlHelper.checkMobile(this.windowWidth);

    this.changeFiltersService.getAllowResetRecipes().subscribe(x => {
      this.allowResetMenu = x;
    });

    this.changeFiltersService.getStateReadyMenu().subscribe(x => {
      if (this.allowResetMenu && !this.isMobile && this.selectedCookbooks.length) {
        this.resetSelected(false);
      }
      this.selectCookBookByHash(this.cookbooksTree, x);
      const filterString = this.composeFilterString();
      const arrNumberFilter = filterString.length > 0 ? filterString.split(',').map(item => +item) : [];
      if (arrNumberFilter !== x) {
        this.booksFiltersAmountCheck.emit(this.selectedCookbooks.length);
        this.recipeService.setFilter('SectionString', filterString).then(() => {
          this.recipeService.get(true);
          this.recipeService.getShort(true);
        });
      }
    });
  }

  selectCookBookByHash(arr: CookbookTreeNode[], arrOfId: number[]) {
    arr.forEach( node => {
      if (node.children) {
        this.selectCookBookByHash(node.children, arrOfId);
      }
      for (const id of arrOfId) {
        if (+id === node.id_Section) {
          let allowAdd = true;
          this.selectedCookbooks.forEach((item, index) => {
            if (item.id_Book === node.id_Book && item.id_Section === node.id_Section)
              allowAdd = false;
          });
          if (allowAdd) {
            this.selectedCookbooks = [];
            this.selectedCookbooks.push(node);
            if (node.parent) node.parent.expanded = true;
          }
        }
      }
    });
  }

  nodeChange(event) {
    if (this.selectedCookbooks.length > 1) {
      this.selectedCookbooks.forEach((item, index) => {
        if (item.id_Book !== event.node.id_Book || item.id_Section !== event.node.id_Section) {
          this.selectedCookbooks.splice(index, 1);
        }
      });
    }
    this.onTreeChange(true);
  }

  onTreeChange(status) {
    const filterString: string = this.composeFilterString();
    this.recipeService.setSearchStatus(true);
    if (status) {
      this.changeFiltersService.showReadyRecipes(filterString.length > 0 ? filterString.split(',') : []);
    }
    this.recipeService.setFilter('SectionString', filterString);
    if (!this.isMobile) {
      this.recipeService.get();
      this.recipeService.getShort();
    }
    const checkRedirect = this.checkCurrentLocation();
    if (checkRedirect) {
      this.router.navigateByUrl('/main/recipes/list');
    }
  }

  checkCurrentLocation(): boolean {
    // TODO: Переделать на indexOf, повторяется во всех фильтрах, следует вынести в хэлпер
    const wayForCheck = window.location.href;
    let firstPosition = (wayForCheck.length - 8);
    let stringForCheck = wayForCheck.substring(firstPosition, wayForCheck.length);
    if (stringForCheck === 'planning') {
      return false;
    }

    firstPosition = (wayForCheck.length - 12);
    stringForCheck = wayForCheck.substring(firstPosition, wayForCheck.length);
    if (stringForCheck === 'recipes') {
      return false;
    }

    firstPosition = (wayForCheck.length - 12);
    stringForCheck = wayForCheck.substring(firstPosition, wayForCheck.length);
    return !(stringForCheck === 'recipes-edit');
  }

  getBlockableElement(): HTMLElement {
    return this.el.nativeElement.children[0];
  }

  convertToCookbookTree(cookbooks: Cookbook[]): CookbookTreeNode[] {
    if (cookbooks == null) {
      return null;
    }

    const cookbooksTree = new Array<CookbookTreeNode>();
    while (cookbooks.length !== 0) {
      const x = cookbooks[0];
      const bookName = x.BookName;

      const children = new Array<CookbookTreeNode>();

      cookbooks.filter(y => y.BookName.trim() === bookName.trim()).forEach(y => {
        const child: CookbookTreeNode = new CookbookTreeNode();
        child.label = y.FullName;
        child.id_Book = y.Id_Book;
        child.id_Section = y.Id_Section;
        children.push(child);

        const spliceIndex = cookbooks.findIndex(e => e.Id_Section === child.id_Section);
        cookbooks.splice(spliceIndex, 1);
      });

      let parentNode: CookbookTreeNode = new CookbookTreeNode();
      parentNode.label = bookName;
      parentNode.isRoot = true;
      parentNode.selectable = false;
      parentNode.styleClass = 'disabled-check-box';
      if (children.length > 1) {
        children.forEach( node => {
          node.parent = parentNode;
        });
        parentNode.children = children;
      } else {
        parentNode = children[0];
        parentNode.label = bookName;
      }

      cookbooksTree.push(parentNode);
    }

    return cookbooksTree;
  }

  composeFilterString() {
    const sectionNumbers = [];
    if (this.selectedCookbooks.length) {
      this.selectedCookbooks.filter(e => !e.isRoot).forEach(e => {
        sectionNumbers.push(e.id_Section);
      });
    }
    const filterString = sectionNumbers.join(',');
    this.countBooksFiltersActive();
    return filterString;
  }

  countBooksFiltersActive() {
    const amount = this.selectedCookbooks.length;
    this.booksFiltersAmountCheck.emit(amount);
  }

  ngOnDestroy() {
    this.cookbooksTree = [];
    this.blockedCookbooksTree = [];
    this.recipeService.clearFilters();
  }

  mobileListToggle() {
    this.mobileListToggleStatus = !this.mobileListToggleStatus;
  }

  mobileListClose() {
    this.mobileListToggleStatus = false;
  }

  resetSelected(statusTreeChange: boolean, book?: CookbookTreeNode) {
    if (book && book.isRoot) {
      this.selectedCookbooks = this.selectedCookbooks.filter( oldBook =>
        !book.children.some( deletedBook =>
          deletedBook.id_Section === oldBook.id_Section
        ) && oldBook.label !== book.label);
    } else {
      this.selectedCookbooks = book && book.id_Section ?
        this.selectedCookbooks.filter(oldBook => oldBook.id_Section !== book.id_Section) : [];
    }
    this.onTreeChange(statusTreeChange);
  }
}



// WEBPACK FOOTER //
// ./src/app/cookbook-filter/cookbook-filter.component.ts